import { useEffect } from 'react'
import { onAuthStateChanged } from 'firebase/auth'
import type { Unsubscribe } from 'firebase/auth'
import {
  useStaffStore,
  useUserStore,
  useOwnerStore,
} from '~/hooks/store'
import { Firebase } from '~/external-services/firebase'

export const useUserAuth = (firebase: Firebase) => {
  const { setUser, removeUser } = useUserStore()
  useEffect(() => {
    const cancelAuthListener: Unsubscribe = onAuthStateChanged(firebase.auth, user => {
      if (user) {
        setUser(user)
      } else {
        removeUser()
      }
    })
    return () => cancelAuthListener()
  }, [])
  return undefined
}

export const useStaffAuth = (firebase: Firebase) => {
  const { setStaff, removeStaff } = useStaffStore()

  useEffect(() => {
    const cancelAuthListener: Unsubscribe = onAuthStateChanged(firebase.auth, staff => {
      if (staff) {
        setStaff(staff)
      } else {
        removeStaff()
      }
    })
    return () => cancelAuthListener()
  }, [])

  return null
}

export const useOwnerAuth = (firebase: Firebase) => {
  const { setOwner, removeOwner } = useOwnerStore()

  useEffect(() => {
    const cancelAuthListener: Unsubscribe = onAuthStateChanged(firebase.auth, owner => {
      if (owner) {
        setOwner(owner)
      } else {
        removeOwner()
      }
    })
    return () => cancelAuthListener()
  }, [])

  return null
}
